import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MapPinIcon, CalendarIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="relative py-16 md:py-20 bg-gradient-to-br from-brand-teal-dark to-brand-navy overflow-hidden" data-id="element-57">
      {/* Background Glows */}
      <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wNSkiLz48L3N2Zz4=')] opacity-20" data-id="element-58"></div>
      <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-brand-laser-red/20 rounded-full blur-[100px] pointer-events-none" data-id="element-59"></div>

      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-60">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center" data-id="element-61">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-62">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-5 leading-[1.1] tracking-tight" data-id="element-63">
              Ready to See If Laser Therapy{' '}
              <span className="text-teal-300" data-id="element-64">Is a Fit?</span>
            </h2>
            <p className="text-base md:text-lg text-teal-50 mb-8 leading-relaxed" data-id="element-65">
              Request a laser therapy consultation at Paragon Chiropractic in
              Bloomfield Hills. The team will answer your questions, explain
              next steps, and help you decide whether Aspen laser therapy may be
              right for you.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mb-8" data-id="element-66">
              <a href="#consultation-form-bottom" className="px-6 py-3.5 bg-brand-teal hover:bg-brand-teal-dark text-white rounded-lg font-bold text-base md:text-lg transition-all duration-300 flex items-center justify-center gap-2 shadow-xl shadow-brand-teal/30" data-id="element-67">
                <CalendarIcon className="w-5 h-5" data-id="element-68" />
                Request Consultation
              </a>
              <a href="tel:+12485902195" className="px-6 py-3.5 bg-white/10 hover:bg-white/20 text-white border border-white/25 rounded-lg font-bold text-base md:text-lg transition-all duration-300 flex items-center justify-center gap-2 backdrop-blur-sm" data-id="element-69">
                <PhoneIcon className="w-5 h-5" data-id="element-70" />
                Call (248) 590-2195
              </a>
            </div>

            <div className="space-y-4 text-teal-100" data-id="element-71">
              <div className="flex items-center gap-3" data-id="element-72">
                <div className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-73">
                  <PhoneIcon className="w-4 h-4" data-id="element-74" />
                </div>
                <div data-id="element-75">
                  <p className="text-[11px] text-teal-200/70 uppercase tracking-wider font-bold" data-id="element-76">
                    Call Us
                  </p>
                  <p className="text-base font-semibold" data-id="element-77">(248) 590-2195</p>
                </div>
              </div>
              <div className="flex items-center gap-3" data-id="element-78">
                <div className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-79">
                  <MapPinIcon className="w-4 h-4" data-id="element-80" />
                </div>
                <div data-id="element-81">
                  <p className="text-[11px] text-teal-200/70 uppercase tracking-wider font-bold" data-id="element-82">
                    Visit Us
                  </p>
                  <p className="text-base font-semibold leading-snug" data-id="element-83">
                    6405 Telegraph Road, Bloomfield Hills, MI 48301
                  </p>
                </div>
              </div>
            </div>

            <p className="mt-8 text-xs text-teal-200/60 italic" data-id="element-84">
              * Individual results vary. A consultation is needed to determine
              whether laser therapy is appropriate.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white rounded-xl p-5 md:p-6 shadow-2xl relative overflow-hidden" id="consultation-form-bottom" data-id="element-85">
            <div className="absolute top-0 left-0 w-full h-1.5 bg-brand-teal" data-id="element-86"></div>

            <div className="inline-block py-0.5 px-2.5 rounded-full bg-brand-teal/10 text-brand-teal-dark text-[10px] font-black tracking-widest uppercase mb-2 mt-1" data-id="element-87">
              Free Consultation
            </div>
            <h3 className="text-lg md:text-xl font-black text-brand-navy mb-1 leading-tight" data-id="element-88">
              Request Your Laser Therapy Consultation
            </h3>
            <p className="text-gray-600 text-xs mb-4 leading-snug" data-id="element-89">
              Ask about the new patient intro offer.
            </p>

            <form className="space-y-3" onSubmit={e => e.preventDefault()} data-id="element-90">
              <input type="text" className="w-full bg-brand-gray-light border border-gray-200 rounded-md px-3 py-2 text-sm text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-transparent transition-all" placeholder="Full Name" data-id="element-91" />

              <div className="grid grid-cols-2 gap-2.5" data-id="element-92">
                <input type="tel" className="w-full bg-brand-gray-light border border-gray-200 rounded-md px-3 py-2 text-sm text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-transparent transition-all" placeholder="Phone" data-id="element-93" />
                <input type="email" className="w-full bg-brand-gray-light border border-gray-200 rounded-md px-3 py-2 text-sm text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-transparent transition-all" placeholder="Email" data-id="element-94" />
              </div>

              <div className="grid grid-cols-2 gap-2.5" data-id="element-95">
                <select className="w-full bg-brand-gray-light border border-gray-200 rounded-md px-3 py-2 text-sm text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-transparent transition-all appearance-none" data-id="element-96">
                  <option value="" data-id="element-97">Best time...</option>
                  <option value="morning" data-id="element-98">Morning</option>
                  <option value="afternoon" data-id="element-99">Afternoon</option>
                  <option value="evening" data-id="element-100">Evening</option>
                </select>
                <select className="w-full bg-brand-gray-light border border-gray-200 rounded-md px-3 py-2 text-sm text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-transparent transition-all appearance-none" data-id="element-101">
                  <option value="" data-id="element-102">Area of interest...</option>
                  <option value="back-neck" data-id="element-103">Back / Neck</option>
                  <option value="shoulder-hip-knee" data-id="element-104">
                    Shoulder / Hip / Knee
                  </option>
                  <option value="foot-heel" data-id="element-105">Foot / Heel</option>
                  <option value="sports-injury" data-id="element-106">Sports / Overuse Injury</option>
                  <option value="arthritis" data-id="element-107">Arthritis / Joint Stiffness</option>
                  <option value="general" data-id="element-108">General Question</option>
                </select>
              </div>

              <textarea rows={2} className="w-full bg-brand-gray-light border border-gray-200 rounded-md px-3 py-2 text-sm text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-teal focus:border-transparent transition-all resize-none" placeholder="Briefly describe what you'd like help with... (optional)" data-id="element-109"></textarea>

              <button className="w-full px-6 py-3 bg-brand-teal hover:bg-brand-teal-dark text-white rounded-lg font-black text-sm md:text-base transition-all duration-300 shadow-md shadow-brand-teal/30 flex items-center justify-center gap-2" data-id="element-110">
                <CalendarIcon className="w-4 h-4" data-id="element-111" />
                Request My Consultation
              </button>

              <p className="text-[10px] text-gray-500 text-center leading-snug" data-id="element-112">
                Please do not submit Protected Health Information (PHI) through
                this form.
              </p>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}